// @ts-nocheck
import { IconPresentationProps } from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@store/MobiusOverrides/Link/Link";
import useIconIndex, { IconKey } from "@store/Framework/Common/Hooks/IconIndex/useIconIndex";
import React from "react";
import { FC } from "react";

export interface LinkIconPropsWithoutSrc {
    position?: "left" | "right";
    iconProps?: Omit<IconPresentationProps, "src">;
}
interface Props extends LinkPresentationProps {
    iconKey?: IconKey;
    iconPropsWithoutSource?: LinkIconPropsWithoutSrc;
}
const HeaderLinkListItem: FC<Props> = ({ iconKey, iconPropsWithoutSource, children, ...otherProps }) => {
    const iconSrc = useIconIndex(iconKey).iconComponent;
    if (!iconSrc) {
        return <Link {...otherProps}>{children}</Link>;
    }
    const iconProps: LinkPresentationProps["icon"] = {
        ...iconPropsWithoutSource,
        iconProps: {
            ...iconPropsWithoutSource?.iconProps,
            src: iconSrc,
        },
    };

    return (
        <Link {...otherProps} icon={iconProps}>
            {children}
        </Link>
    );
};

export default HeaderLinkListItem;
